import WOSEdit from './Edit';
import React from "react";
import MaterialTable from "material-table";
import SideDrawer from '../../../Components/SideDrawer';
import { createTheme, ThemeProvider } from "@mui/material";
import { DestroyResourceAction } from "../../../Redux/Actions/CrudActions";
import { useSelector, useDispatch } from 'react-redux';
import { Spinner } from '../../../Components/Spinner';
import { isMobile } from 'react-device-detect';


const WorkOrderStatusGird = ({ columns, dataList, setDataList, Title, HandleDrawerCreate }) => {
    const ACTION_TYPE = "COMMON";
    const BACKEND_ROUTE = "master-work-order-statuses";
    const theme = createTheme();

    const [id, setID] = React.useState(null);
    const [editDrawerStatus, setEditDrawerStatus] = React.useState(null);

    const state = useSelector(state => state.common);

    const dispatch = useDispatch();

    const HandleEditDrawer = (event) => {
        if (editDrawerStatus) {
            setID(null);
            setEditDrawerStatus(false);
        }
    }
    const HandleEdit = (rowData) => {
        setID(rowData.id);
        setEditDrawerStatus(true);
    }

    const handleDelete = (oldData) => {
        var ID = oldData.id;
        dispatch(DestroyResourceAction(BACKEND_ROUTE, ID, ACTION_TYPE));
        console.log(state);
    }

    return (
        <ThemeProvider theme={theme}>
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    columns={columns.columns}
                    data={dataList}
                    title={isMobile ? '': Title}
                    isLoading={state.all.loading}
                    actions={[
                        {
                            icon: 'edit',
                            tooltip: 'Edit',
                            onClick: (event, rowData) => HandleEdit(rowData)
                        },
                        {
                            icon: () => (isMobile)
                            ?<i className="fa-solid fa-plus theme-text-color-primary" style={{fontSize: '1.2rem'}}></i> 
                            :<span className="btn btn-sm btn-theme-primary ml-2">Create a Work Order Status</span>,
                            tooltip: 'Create a Work Order Status',
                            isFreeAction: true,
                            onClick: (event, rowData) => HandleDrawerCreate()
                        },
                    ]}
                    editable={{
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    const data = [...dataList]
                                    data.splice(data.indexOf(oldData), 1);
                                    setDataList(data)
                                    handleDelete(oldData)
                                }, 600);
                            }),
                    }}
                    options={{
                        actionsColumnIndex: 0
                    }}
                />
            </div>
            <SideDrawer status={editDrawerStatus} handle={HandleEditDrawer} >
                {id && <WOSEdit ID={id} />}
            </SideDrawer>
        </ThemeProvider>
    );
}

// export default Form;
export default WorkOrderStatusGird;